import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FieldPath } from '../../../core';
import { getFieldValueByFieldPathSelector } from '../../stateSelector';
import { RootState } from '../../types';
import { useWatchField } from '../internal';
import useFormId from '../useFormId';

function useValue<T>(fieldPath: FieldPath, defaultValue?: T): T {
  useWatchField(fieldPath);
  const formId = useFormId();
  const selector = useCallback(
    (state: RootState<T>) =>
      getFieldValueByFieldPathSelector(state, formId, fieldPath, defaultValue),
    [formId, fieldPath, defaultValue],
  );
  return useSelector(selector);
}

export default useValue;
